<script setup lang="ts">
  import { Toaster as Sonner } from "vue-sonner";
  import "vue-sonner/style.css";
  import { DismissAllButton } from "@/components/episto-ui/toast";

  defineProps<{
    position?: "top-left" | "top-right" | "bottom-left" | "bottom-right" | "top-center" | "bottom-center";
    expand?: boolean;
    visibleToasts?: number;
  }>();
</script>

<template>
  <Sonner
    class="toaster print:hidden"
    theme="light"
    :position="position ?? 'bottom-right'"
    :expand="expand ?? true"
    :visible-toasts="visibleToasts ?? 3"
    :gap="8" />
  <DismissAllButton />
</template>
